import React, { useState, useEffect } from 'react';
import CalendarGrid from './CalendarGrid';
import MonthNavigator from './MonthNavigator';
import AddressForm from '../forms/AddressForm';
import CredentialsForm from '../forms/CredentialsForm';
import { useReservation } from "../hooks/useReservation";
import ConfirmationForm from '../forms/ConfirmationForm';
import ReservationConfirmed from '../forms/ReservationConfirmed';
import FormNavigator from '../forms/formNavigator';
import PriceCalculator from '../PriceCalculator';
const monthNames = [
  'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
  'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień',
];
const daysNames = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Ni'];

const Calendar = ({setIsLoggedIn, setInProgress}) => {
  const [initial,setInitial] = useState(true)
  const [actualDate] = useState(new Date());
  const [actualYear, setActualYear] = useState(new Date().getFullYear());
  const [actualMonth, setActualMonth] = useState(new Date().getMonth());
  const [formPage, setFormPage] = useState(0);
  const [blocked, setBlocked] = useState(false);
  const [availableHours, setAvailableHours] = useState([]);
  const [startHour, setStartHour] = useState(null);
  const [endHour, setEndHour] = useState(null);
  const [calendarText,setCalendarText] = useState(`Wybierz datę`)
  const [city, setCity] = useState(``);
  const [link,setLink] = useState();
  const [service, setService] = useState(``);
  const [address, setAddress] = useState(``);
  const [animation, setAnimation] = useState(null); 
  const [gridKey, setGridKey] = useState(0);
  const [referralCode, setReferralCode] = useState(``);
  const [description, setDescription] = useState(``);
  const [amount, setAmount] = useState(20);
  const [activeCalculator, setActiveCalculator] = useState(true)

  const [userData, setUserData] = useState({
    name: "",
    surname: "",
    email: "",
    password: "",
    repeatPassword: "",
    telephoneNumber: "",
  });
  const { handleDayClick, selectedDate } = useReservation({ 
    actualYear, 
    actualMonth,
    setFormPage, 
    setAvailableHours,
  });
  const firstDayOfMonth = new Date(actualYear, actualMonth, 1);
  const lastDayOfMonth = new Date(actualYear, actualMonth + 1, 0);
  const totalDaysInMonth = lastDayOfMonth.getDate();
  const startDay = (firstDayOfMonth.getDay() + 6) % 7;

  useEffect(() => {
  if (formPage > 0) {
    window.scrollTo({
      top: document.querySelector('.calendary-section').offsetTop - 100,
      behavior: 'smooth'
    });
  }
}, [formPage]);

  useEffect(() => {
      if(!formPage) {
        setActiveCalculator(true);
      }else {
        setActiveCalculator(false);
      }
  },[formPage])

  const nextMonth = () => {
    if(blocked) {
      return
    }
    setBlocked(true)
    setAnimation('next');
    setTimeout(() => {
      setActualMonth((prev) => (prev === 11 ? 0 : prev + 1));
      setActualYear((prev) => (actualMonth === 11 ? prev + 1 : prev));
      setAnimation('fadeInFromRight'); 
      setGridKey((prev) => prev + 1);
      setTimeout(() => {
        setAnimation(null)
        setBlocked(false)
      }, 300); 
    }, 500);
  };

  const prevMonth = () => {
    if(blocked) {
      return
    }
    setBlocked(true)
    setAnimation('previous');
    setTimeout(() => {
      setActualMonth((prev) => (prev === 0 ? 11 : prev - 1));
      setActualYear((prev) => (actualMonth === 0 ? prev - 1 : prev));
      setAnimation('fadeInFromLeft');
      setGridKey((prev) => prev + 1); 
      setTimeout(() => {
        setAnimation(null)
        setBlocked(false)
      }, 500); 
    }, 500);
  };


  // if (blocked) return;
  // if (actualMonth !== 0) {
  //   if (formPage <= 0) {
  //     setActualMonth(actualMonth - 1);
  //   } else {
  //     setBlocked(true);
  //     setFormPage(formPage - 1);
  //     setTimeout(() => setBlocked(false), 500);
  //   }
  // } else if (formPage <= 0) {
  //   setActualYear(actualYear - 1);
  //   setActualMonth(11);
  // } else {
  //   setBlocked(true);
  //   setFormPage(formPage - 1);
  //   setTimeout(() => setBlocked(false), 500);
  // }




  const renderContent = () => {
    switch (formPage) {
      case 0:
        return (
          <>
            <div id="days-container" className="calendar-days">
              {daysNames.map((day) => (
                <div key={day} className="day">{day}</div>
              ))}
            </div>
            <div className={`calendar-wrapper ${animation || ''}`}>
            <CalendarGrid
            key={gridKey}
           totalDays={totalDaysInMonth}
           startDay={startDay}
           actualDate={actualDate}
           actualMonth={actualMonth}
           actualYear={actualYear}
           onDayClick={handleDayClick}
           setInProgress={setInProgress}
            />
            </div>

          </>
        );
      case 1:
        return <AddressForm calendar={{ 
          availableHours,
          link,
          address,
          setCity,
          setService, 
          setFormPage ,
          setStartHour,
          setEndHour,
          setLink,
          setAddress,
          setReferralCode,
          setInProgress,
          amount,
          setAmount
        }} />;
      case 2:
        return <CredentialsForm calendar={{ formPage, setFormPage,userData,setUserData, setIsLoggedIn }} />;
      case 3:
        return <ConfirmationForm amount={amount} setDescription={setDescription} setUserData={setUserData} referralCode={referralCode} userData = {userData} service={service} city={city} address={address} startHour={startHour} endHour={endHour} link={link} selectedDate={selectedDate} setFormPage={setFormPage}  />
      case 4:
        return <ReservationConfirmed description={description} setInProgress={setInProgress} />
      default:
        return null;
    }
  };


  useEffect(() => {
    setInitial(false)
  },[formPage])

  return (
    <section className={`calendary-section`} key={formPage}>
      {activeCalculator ? <PriceCalculator active={activeCalculator}></PriceCalculator> : <></>}
      <div id="calendar-container" className={`calendary ${formPage === 0 && initial ? "fadeInFromLeft":"opacity" } `}>
        <div id="calendar-header-flex-container">
          {formPage === 0 ? 
          <>
             <h3 id="calendar-text">
            {calendarText}
          </h3>
          <MonthNavigator
          month={monthNames[actualMonth]}
          year={actualYear}
          onPrev={prevMonth}
          onNext={nextMonth}
        />
          </>

          : <FormNavigator 
          formPage={formPage}
          setFormPage={setFormPage}
          />}

        </div>
        <div className="calendar-container">{renderContent()}</div>
      </div>
    </section>
  );
};

export default Calendar;